<div class="selector-container" [ngStyle]="{ 'width':width }">
  <div class="select-custom"
    [ngClass]="{ 'focused' : focused , 'disabled' : disabled }"
    (click)="toggleFocus()"
    (mouseenter)="onMouseOver()"
    (mouseleave)="onMouseLeft()">
    <div class="selected-item" [ngClass]="{ 'placeholder' : selectedItem == '' || disabled }" style="font-size: 16px">
      @if (titleCase) {
        {{ (selectedItem != '' ? selectedItem : placeHolder) | titlecase }}
      }
      @if (titleCase == false ) {
        {{ (selectedItem != '' ? selectedItem : placeHolder) }}
      }
    </div>
    <i class="arrow-down"
    [ngClass]="{ 'arrow-focused' : hovered || focused }"></i>
  </div>
  @if (focused) {
    <div class="select-custom-options"
      (mouseleave)="hideDropdown()">
      @for (i of items; track i; let index = $index) {
        <div [ngClass]="{ 'selected' : i === selectedItem }"
          (click)="onItemSelected(i); onIndexSelected(index) ">
          @if (titleCase) {
            {{ i | titlecase }}
          }
          @if (titleCase == false ) {
            {{ i }}
          }
        </div>
      }
    </div>
  }
</div>
